"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function runCallbacks(callbackArray, event) {
    var callbacks = callbackArray.slice();
    callbacks.forEach(function (callback) {
        callback(event);
    });
}
exports.runCallbacks = runCallbacks;
